import {Helmet} from 'react-helmet';
import styles from './UnauthorizedPageTitle.module.sass';

export interface IUnauthorizedPageTitleProps {
    pageTitle: React.ReactNode;
    titleTag: string;
    subtitle?: string;
    metaTitle?: string;
    metaDescription?: string;
    metaKeywords?: string;
}

const UnauthorizedPageTitle = ({
    pageTitle,
    subtitle = '',
    metaTitle,
    metaDescription,
    titleTag,
    metaKeywords,
}: IUnauthorizedPageTitleProps) => (
    <>
        <Helmet>
            <title>{titleTag}</title>
            {metaTitle ? <meta name="title" content={metaTitle} /> : null}
            {metaDescription ? (
                <meta name="description" content={metaDescription} />
            ) : null}
            {metaKeywords ? (
                <meta name="keywords" content={metaKeywords} />
            ) : null}
        </Helmet>
        <div className={styles.pageTitle}>
            <h3>{pageTitle}</h3>
            {subtitle ? <p>{subtitle}</p> : null}
        </div>
    </>
);

export default UnauthorizedPageTitle;
